import React, { Component } from 'react';
//import { logout } from './AuthService';
import { Redirect } from "react-router-dom";
//import { getProfile } from './ApiService';
import Load from './Load';
import NavBar from './NavBar';
import Footer from './Footer';


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      loading: true,
      profile: {}
    }
  }

  // logout() {
  //   logout();
  //   this.setState({
  //     redirect: true
  //   });
  // }

  componentWillMount() {
    var self = this;
    self.setState({
      loading:false
    });
    // getProfile(this.props.token, function(result) {
    //   self.setState({
    //     profile:result.data,
    //     loading:false
    //   });
    // }, function(error) {
    //   console.log(error);
    // });
  }

  render() {
    const { redirect } = this.state;
    if (redirect) {
      return <Redirect to='/'/>;
    }

    return (
      this.state.loading?
      (<Load/>)
      :
      (
        <div className='row'>
          <div className='col'>
            <NavBar/>
            <br/>
            <br/>
            <div className='row'>
              <div className='col' align='center'>
                <h2>Em Desenvolvimento</h2>
              </div>
            </div>
            <br/>
            <br/>
            <Footer/>
          </div>
        </div>

      )
    );
  }
}

export default Home;
